import { createContext } from 'react';

import { FormyProvider } from '../types/form';

const context = createContext<FormyProvider | undefined>(undefined);

export { context };
